export default "__VITE_ASSET__Dn$O8iL4__"